import { render, staticRenderFns } from "./FooterNew.vue?vue&type=template&id=69cd604a&scoped=true&"
import script from "./FooterNew.vue?vue&type=script&lang=js&"
export * from "./FooterNew.vue?vue&type=script&lang=js&"
import style0 from "./FooterNew.vue?vue&type=style&index=0&id=69cd604a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cd604a",
  null
  
)

export default component.exports